import {SocketDataTypes} from '../../../../../shared/SocketDataTypes'
import {createTDIn, setElementInnerHTML} from '../../ui_utils/DomUtils'
import {UILobbyTableRowPlayersController} from './UILobbyTableRowPlayersController'
import {MapDataController} from '../../../../../shared/map_data/MapDataController'
import {GameModeDataController} from '@colonist/shared-types'
import {ModeSettingEnum, PlayerEnums} from '../../../../../shared/GameEnums'
import {logError} from '../../ui_utils/Utils'
import {UILobbyTableRowHighKarmaController} from './UILobbyTableRowHighKarmaController'
import {getDefaultMapForGameMode} from '@colonist/types'

export class UILobbyTableRowController {
    private roomData: SocketDataTypes.LobbyRowData
    private readonly tableRow: HTMLTableRowElement

    private readonly tdMode: HTMLTableCellElement
    private readonly tdMap: HTMLTableCellElement
    private readonly tdSpeed: HTMLTableCellElement
    private readonly highKarmaIcon: UILobbyTableRowHighKarmaController
    private readonly players: UILobbyTableRowPlayersController

    private readonly TRANSITION_TIME_MS = 300

    constructor(container: HTMLElement, roomData: SocketDataTypes.LobbyRowData, buttonAction: (gameId: string) => void) {
        this.tableRow = this.createRowElement()
        container.appendChild(this.tableRow)
        this.tdMode = createTDIn(this.tableRow)
        this.tdMap = createTDIn(this.tableRow)
        this.tdSpeed = createTDIn(this.tableRow)
        const tdHighKarma = createTDIn(this.tableRow, 'lobby_table_data_high_karma')
        const tdPlayers = createTDIn(this.tableRow, 'lobby_table_data_players')

        this.highKarmaIcon = new UILobbyTableRowHighKarmaController(tdHighKarma, roomData)
        this.players = new UILobbyTableRowPlayersController(tdPlayers, roomData)

        this.roomData = roomData

        this.tableRow.onclick = () => {
            buttonAction(roomData.id)
        }
    }

    // eslint-disable-next-line class-methods-use-this
    private createRowElement(): HTMLTableRowElement {
        const row = document.createElement('tr')
        row.classList.add('transitioning')
        setTimeout(() => {
            row.classList.remove('transitioning')
        }, this.TRANSITION_TIME_MS)
        return row
    }

    update(roomData: SocketDataTypes.LobbyRowData) {
        this.players.update(roomData.players, roomData.maxPlayers, this.roomData)
        this.highKarmaIcon.update(roomData.minimumKarma, this.roomData)
        const newMode = roomData.modePlayable ? roomData.gameModeSetting : ModeSettingEnum.Classic4P
        const newModeSetting = GameModeDataController.getModeDataForMode(newMode)?.name
        const newModeSettingText = newModeSetting ?? {key: 'strings:colonistCommon.utils.emptyString'}
        const newMapSetting = MapDataController.getMapDataForMap(roomData.mapPlayable ? roomData.gameMapSetting : getDefaultMapForGameMode(newMode))?.name
        const newMapSettingText = newMapSetting ?? {key: 'strings:colonistCommon.utils.emptyString'}
        if(newMapSetting == undefined || newModeSetting == undefined) {
            logError('update', ['Error no such mode ' + roomData.gameModeSetting])
            logError('update', ['Error no such map ' + roomData.gameMapSetting])
            return
        }

        setElementInnerHTML(this.tdMode, newModeSettingText)
        setElementInnerHTML(this.tdMap, newMapSettingText)
        setElementInnerHTML(this.tdSpeed, PlayerEnums.getSpeedSettingText(roomData.speed))
        this.roomData = roomData
    }

    remove() {
        this.tableRow.classList.add('transitioning')
        setTimeout(() => {
            if(!this.tableRow.parentElement) return
            this.tableRow.parentElement.removeChild(this.tableRow)
        }, this.TRANSITION_TIME_MS)
    }

    getId(): string {
        return this.roomData.id
    }

    setRoomAvailable(userKarma: number | undefined, unavailable: boolean | undefined) {
        const isUnavailable = unavailable || ((userKarma !== undefined) && (userKarma < this.roomData.minimumKarma))

        this.tableRow.classList.toggle('lobby_table_row_unavailable', isUnavailable ?? false)
    }
}
